import React, { Component } from 'react';
import aboutData from '../../resources/json/about.json';
import ContainerPaper from '../paper/ContainerPaper';
import { desktopMainContainer, desktopContentContainerPaperStyle } from '../../styles/shared/desktop';
import { sectionHeaderStyle, subSectionHeaderStyle, sectionTextStyle} from '../../styles/shared/variables';
import { desktopContentContainerPaperDivStyle, aboutMeHeaderStyle} from './styles/desktop';
import {generateImage,generateStandAloneLink,generateText,generateVideo} from '../common/dynamic/DynamicConentGeneratorFunctions';
import { mobileMainContainer } from '../../styles/shared/mobile';

export default class CourseList extends Component {

    constructor(props) {
        super(props);
    }

    generateSections() {
        return aboutData.map(function (section) {
            return (
                <div key={section.sectionCode + '-text-container'} >
                    <div key={section.sectionCode + '-text-container-header'} style={subSectionHeaderStyle}>
                        {section.sectionTitle}
                    </div>
                    <div id={section.sectionCode + '-text-container-text'} key={section.sectionCode + '-text-container-text'} style={sectionTextStyle}>
                        {section.sectionText}
                    </div>
                </div>
            )
        });
    }

    generateContentData() {
     
            return aboutData.content.map(function (contentItem, index) {
                if (contentItem.contentType.toLowerCase() === 'text') {
                    return generateText(contentItem.content, index);
                }
                else if (contentItem.contentType.toLowerCase() === 'image') {
                    return generateImage(contentItem.content, index, aboutData.referenceFiles);
                } else if (contentItem.contentType.toLowerCase() === 'standalonelink') {
                    return generateStandAloneLink(contentItem.content, index, aboutData.referenceFiles);
                } else if (contentItem.contentType.toLowerCase() === 'video') {
                    return generateVideo(contentItem.content, index, aboutData.referenceFiles)
                } else {
                    return generateText(contentItem.content, index);

                }
            }, this);
    

    }
    
    // generateContactForm() {
    //     return (<TextPaperCard style={styles.contactContainer} zDepth={5} rounded={true}>
    //         <div style={styles.sectionHeader}>
    //             <h2>Contact Me</h2>
    //         </div>

    //     </TextPaperCard>
    //     )
    // }
    render() {
        const { deviceType } = this.props;
        let showMobile = deviceType === 'mobile' ? true : false;
        return (
            <div id='aboutme-page-container' style={showMobile ? mobileMainContainer : desktopMainContainer}>
                <ContainerPaper id={'projects-page-sub-container'} style={desktopContentContainerPaperStyle}>
                    <div id='container-paper-content-div' style={desktopContentContainerPaperDivStyle}>
                        <div style={{...sectionHeaderStyle, ...aboutMeHeaderStyle}}>
                            About Me
                        </div>
                    </div>
                    {this.generateContentData()}
                </ContainerPaper>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/about/About.js